import React from 'react';
import PropTypes from 'prop-types';

import LiquidInput from './liquid_input';

export const valueTypes = {
  exact: 'exact',
  liquid: 'liquid'
};

class OptionalLiquidInput extends React.Component {
  static propTypes = {
    liquidContext: PropTypes.object.isRequired,
    name: PropTypes.string,
    renderExactInput: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.bool, PropTypes.object, PropTypes.string]),
    valueType: PropTypes.string.isRequired,

    onValidityChange: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired,
    onValueTypeChange: PropTypes.func.isRequired
  }

  handleValueTypeChange = (event) => {
    this.props.onValueTypeChange(event.target.value, this.props.name);
  }

  render() {
    return (
      <div className="liquid-overridable-input-wrapper">
        <select
          className="value-type form-control"
          value={this.props.valueType}
          onChange={this.handleValueTypeChange}
        >
          <option value={valueTypes.exact}>Exact</option>
          <option value={valueTypes.liquid}>Liquid</option>
        </select>

        {
          this.props.valueType === valueTypes.liquid
            ? this.renderLiquidInput()
            : this.props.renderExactInput()
        }
      </div>
    );
  }

  renderLiquidInput() {
    return (
      <LiquidInput
        liquidContext={this.props.liquidContext}
        name={this.props.name}
        value={this.props.value}
        onValidityChange={this.props.onValidityChange}
        onValueChange={this.props.onValueChange}
      />
    );
  }
}

export default OptionalLiquidInput;
